<template>
  <div class="table">
    <el-table
      ref="multipleTable"
      :data="tableData"
      :highlight-current-row="true"
      tooltip-effect="dark"
      style="width: 100%; color: #858585"
      @selection-change="selectRow"
      :header-cell-style="tableHeaderCellStyle"
    >
      <el-table-column type="selection" fill="#00CCCC" fixed="left">
      </el-table-column>
      <!-- 表头开始 -->
      <el-table-column
        prop="name"
        label="申请人姓名"
        show-overflow-tooltip
        align="center"
      >
      </el-table-column>
      <el-table-column prop="gender" label="性别" align="center">
      </el-table-column>
      <el-table-column
        prop="mobile"
        label="手机号"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="applyDate"
        label="申请时间"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="orgName"
        label="机构"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="deptName"
        align="center"
        label="科室"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="jobTitle"
        align="center"
        label="职位"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="status"
        align="center"
        label="状态"
        show-overflow-tooltip
      >
      </el-table-column>
      <!-- <el-table-column
          align="center"
          label="">
           <template slot-scope="scope">
           <span style="display: inline-block;background-color: #CEF8F8;border-radius: 15px;width: 86px;color:#00CCCC" v-if="scope.row.status=='正常'">{{scope.row.status}}</span>
           <span style="display: inline-block;background-color: #FFC2C2;border-radius: 15px;width: 86px;color:#FC5555" v-if="scope.row.status=='禁用'">{{scope.row.status}}</span>
          </template>
        </el-table-column> -->
      <el-table-column align="center" label="操作" width="120">
        <template slot-scope="scope">
          <span
            style="color: #00cccc; cursor: pointer"
            @click="clickRow(scope.row)"
            >查看详情</span
          >
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <div class="page">
      <!-- left -->
      <span class="pageLeft"
        >共 {{ count }} 条记录 第 {{ currentPage }} / {{ tatalPage }}页</span
      >
      <!-- right -->
      <el-pagination
        @size-change="SizeChange"
        background
        @current-change="CurrentChange"
        @prev-click="prevClick"
        @next-click="nextClick"
        :current-page="currentPage"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="onlyPage"
        :pager-count="5"
        layout="sizes, prev, pager, next, jumper"
        :total="count"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import { applyList } from '@/api/expert.js';
import { getHospitalList } from '@/api/order.js';
export default {
  data() {
    return {
      tableData: [], //表格数据
      multipleSelection: [], // tableCheckboxValue
      // 分页相关
      currentPage: 1, // 当前页面,默认1
      tatalPage: 0, //总页数,为加载时先为0，页面首次加载后去请求即可
      count: 0, //总的条数记录
      onlyPage: 10 // 当前页面可以展示多少条数据,默认10
    };
  },

  mounted() {
    //当前账户绑定机构
    getHospitalList({}).then((res) => {
      if (res.data.status == 200) {
        this.hospitalId = res.data.data.id;
        this.getData(1, 10);
      } else {
        this.$message.error(res.data.message);
      }
    });
  },

  methods: {
    //表头样式回调
    tableHeaderCellStyle() {
      return 'color:#fff;background-color:#00CCCC';
    },
    // getData
    getData(currentPage, onlyPage, applyDate, prCode, cityCode, name, status) {
      const rLoading = this.openLoading(); // 开始loading
      applyList({
        currentPage: currentPage,
        pageSize: onlyPage,
        name: name,
        applyDate: applyDate,
        provinceCode: prCode,
        cityCode: cityCode,
        status: status,
        orgId: this.hospitalId
      })
        .then((res) => {
          if (res.data.status == 200) {
            this.tableData = res.data.data.records;
            this.tatalPage = parseInt(res.data.data.size);
            this.count = parseInt(res.data.data.total);
            rLoading.close(); // 关闭loading
          } else {
            this.$message.error(res.data.message);
          }
        })
        .catch((res) => {
          this.$message.error(res);
        });
    },
    // 复选框选项
    selectRow(val) {
      this.multipleSelection = val;
    },
    // 分页相关
    SizeChange(val) {
      this.onlyPage = val;
      this.getData(
        this.currentPage,
        this.onlyPage,
        this.$parent.roomid,
        this.$parent.submitOption,
        this.$parent.seachDate
      );
    },
    CurrentChange(val) {
      this.currentPage = val;
      this.getData(
        this.currentPage,
        this.onlyPage,
        this.$parent.roomid,
        this.$parent.submitOption,
        this.$parent.seachDate
      );
    },
    prevClick(val) {
      // 上一页
      this.currentPage = val;
      this.getData(
        this.currentPage,
        this.onlyPage,
        this.$parent.roomid,
        this.$parent.submitOption,
        this.$parent.seachDate
      );
    },
    nextClick(val) {
      this.currentPage = val;
      this.getData(
        this.currentPage,
        this.onlyPage,
        this.$parent.roomid,
        this.$parent.submitOption,
        this.$parent.seachDate
      );
    },
    //单击表格行
    clickRow(e) {
      // console.log("ee",e)
      this.$router.push({
        name: 'ViewApply',
        query: {
          id: e.id,
          status: e.status
        }
      });
    }
  }
};
</script>
<style scoped>
.table {
  margin-top: 0.1563rem;
}
.el-button {
  color: #00a3a3 !important;
}
.action {
  display: flex;
  flex-direction: column;
}
.actionP {
  cursor: pointer;
  color: #00cccc;
  margin: 0 !important;
}
.resoult {
  text-align: left;
}
.page {
  display: flex;
  margin-top: 0.3125rem;
  justify-content: space-between;
  align-items: center;
}
.pageLeft {
  color: #858585;
  font-size: 0.1094rem;
  line-height: 0.1875rem;
}
.el-pagination {
  color: #858585 !important;
  font-size: 0.1094rem !important;
  line-height: 0.1875rem !important;
}
</style>
